// Services data constants
export const SERVICES_LIST = [
  'Additions',
  'Roofing',
  'Bathrooms',
  'Kitchens',
  'Foundations',
  'Cement',
  'Tile Work',
  'Basements',
  'Mechanicals',
  'Electrical',
  'Plumbing',
  'MEP',
  'Siding',
  'Full Gut Rehabs',
  'Framing',
  'HVAC',
  'Painting',
  'Drywall',
  'Windows & Doors',
  'Fences & Decks'
];

export const FINANCING_FEATURES = [
  {
    icon: 'FaCreditCard',
    title: '100% Financing',
    description: 'Qualified applicants can finance up to 100% of their project'
  },
  {
    icon: 'FaDollarSign',
    title: 'Competitive Rates',
    description: 'Low interest rates and flexible terms available'
  },
  {
    icon: 'FaCheckCircle',
    title: 'Quick Approval',
    description: 'Fast and easy application process with same-day decisions'
  }
];
